<template>
    <v-app>
        <!-- DEPARTMENTS DRAWER ----------------------------------------------------------------------------------------------------->
        <v-navigation-drawer
            v-model="drawer"
            location="left"
            width="280"
            theme="light"
            style="font-size: 20px; background: #3b3d4d; color: whitesmoke"
            :permanent="screenWidth > 1024"
            :temporary="screenWidth <= 1024"
        >
            <v-list density="compact" nav>
                <v-list-item>
                    <template v-slot:prepend>
                        <v-avatar size="50">
                            <v-img
                                v-if="fullName"
                                :src="`https://connectv2.d3llc.org/images/hr/HRUsersImagesUS/${fullName
                                    .replace(/\s+/g, '.')
                                    .toLowerCase()}.jpg`"
                            />
                        </v-avatar>
                    </template>

                    <v-list-item-title>Welcome,</v-list-item-title>
                    <v-list-item-subtitle>{{ fullName }}</v-list-item-subtitle>
                </v-list-item>

                <!--Additive Manufacturing--->
                <v-list-group
                    v-if="can('Additive Manufacturing')"
                    value="ADM"
                    color="whitesmoke"
                >
                    <template v-slot:activator="{ props }">
                        <v-list-item
                            prepend-icon="mdi:mdi-printer-3d-nozzle"
                            v-bind="props"
                            title="Additive Manufacturing"
                        ></v-list-item>
                    </template>
                    <Link
                        :href="route('ADM-opsDash')"
                        @click="setDepartment('ADM')"
                    >
                        <v-list-item
                            rounded="xl"
                            title="Additive Manufacturing Dashboard"
                            value="ADMDashboard"
                            color="#d9e3f0"
                        ></v-list-item>
                    </Link>
                    <Link
                        :href="route('ADM-resourceLinks')"
                        @click="setDepartment('ADM')"
                    >
                        <v-list-item
                            rounded="xl"
                            title="Printer Resource Links"
                            value="PrinterResourceLinks"
                            color="#d9e3f0"
                        ></v-list-item>
                    </Link>
                </v-list-group>

                <!--Assembly--->
                <v-list-group
                    v-if="can('page Assembly')"
                    value="ASM"
                    color="whitesmoke"
                >
                    <template v-slot:activator="{ props }">
                        <v-list-item
                            prepend-icon="mdi:mdi-hammer"
                            v-bind="props"
                            title="Assembly"
                        ></v-list-item>
                    </template>
                    <Link
                        :href="route('assembly-dashboard')"
                        @click="setDepartment('ASM')"
                    >
                        <v-list-item
                            rounded="xl"
                            title="Assembly Dashboard"
                            value="ASMDashboard"
                            color="#d9e3f0"
                        ></v-list-item>
                    </Link>
                    <Link
                        :href="route('ASM-opsDash')"
                        @click="setDepartment('ASM')"
                    >
                        <v-list-item
                            rounded="xl"
                            title="Assembly Ops Dashboard"
                            value="ASMOPSDashboard"
                            color="#d9e3f0"
                        ></v-list-item>
                    </Link>
                    <Link
                        v-if="can('Punch labor dtl')"
                        :href="route('hr.labor-dtl')"
                        @click="setDepartment('ASM')"
                    >
                        <v-list-item
                            rounded="xl"
                            color="#d9e3f0"
                            title="Employee Punch Detail"
                            value="ASMEmpJobDetail"
                        ></v-list-item>
                    </Link>
                    <Link
                        :href="route('assembly-endOfJob')"
                        @click="setDepartment('ASM')"
                    >
                        <v-list-item
                            rounded="xl"
                            title="End Of Job"
                            value="ASMEndOfJob"
                            color="#d9e3f0"
                        >
                        </v-list-item>
                    </Link>
                    <!--                    <Link-->
                    <!--                        v-if="can('Edit labor dtl')"-->
                    <!--                        :href="route('itDepartment-fixEmployeePunch')"-->
                    <!--                    >-->
                    <!--                        <v-list-item-->
                    <!--                            rounded="xl"-->
                    <!--                            title="Fix Employee Punch"-->
                    <!--                            value="ASMFixEmployeePunch"-->
                    <!--                            color="#d9e3f0"-->
                    <!--                        ></v-list-item>-->
                    <!--                    </Link>-->
                    <Link
                        :href="route('project-management')"
                        @click="setDepartment('ASM')"
                    >
                        <v-list-item
                            rounded="xl"
                            title="Project Progress"
                            value="ASMProjectManagement"
                            color="#d9e3f0"
                        ></v-list-item>
                    </Link>

                    <Link
                        v-if="can('page Shift Calendar')"
                        :href="route('ASM-shiftCalendar')"
                        @click="setDepartment('ASM')"
                    >
                        <v-list-item
                            rounded="xl"
                            title="Shift Calendar"
                            value="ASMShiftCalendar"
                            color="#d9e3f0"
                        >
                        </v-list-item>
                    </Link>
                    <Link
                        :href="route('purchasing-supplyRequestDash')"
                        @click="setDepartment('ASM')"
                    >
                        <v-list-item
                            title="Supply Request"
                            rounded="xl"
                            color="#d9e3f0"
                            value="SupplyRequestFormASM"
                        ></v-list-item>
                    </Link>
                    <Link
                        :href="route('project-request-material')"
                        @click="setDepartment('ASM')"
                    >
                        <v-list-item
                            rounded="xl"
                            title="Request Material"
                            value="ASMRequestMaterial"
                            color="#d9e3f0"
                        ></v-list-item>
                    </Link>
                    <Link
                        :href="route('ASM-resourceLinks')"
                        @click="setDepartment('ASM')"
                    >
                        <v-list-item
                            rounded="xl"
                            title="Tablet Resource Links"
                            value="ASMTabletResourceLinks"
                            color="#d9e3f0"
                        ></v-list-item>
                    </Link>
                    <Link
                        v-if="can('Edit labor dtl')"
                        :href="route('hr.time-expense')"
                        @click="setDepartment('ASM')"
                    >
                        <v-list-item
                            rounded="xl"
                            title="Time Expense"
                            value="ASMTimeExpense"
                            color="#d9e3f0"
                        ></v-list-item>
                    </Link>
                    <Link
                        :href="route('ASM-help')"
                        @click="setDepartment('ASM')"
                    >
                        <v-list-item
                            title="Help"
                            value="ASMHelp"
                            color="#d9e3f0"
                            rounded="xl"
                            append-icon="mdi:mdi-help-circle-outline"
                        ></v-list-item>
                    </Link>
                </v-list-group>

                <!---CNC---->
                <v-list-group
                    color="whitesmoke"
                    v-if="can('page CNC')"
                    value="CNC"
                >
                    <template v-slot:activator="{ props }">
                        <v-list-item
                            prepend-icon="mdi:mdi-circular-saw"
                            v-bind="props"
                            title="CNC"
                        ></v-list-item>
                    </template>
                    <Link
                        v-if="can('page CNC')"
                        :href="route('CNC-approval')"
                        @click="setDepartment('CNC')"
                    >
                        <v-list-item
                            rounded="xl"
                            title="Approvals"
                            value="CNCApprovals"
                            color="#d9e3f0"
                        ></v-list-item>
                    </Link>
                    <Link
                        v-if="can('page CNC')"
                        :href="route('CNC-routeCNCOpsDash')"
                        @click="setDepartment('CNC')"
                    >
                        <v-list-item
                            rounded="xl"
                            title="CNC Ops Dashboard"
                            value="CNCOPEDashboard"
                            color="#d9e3f0"
                        ></v-list-item>
                    </Link>
                    <Link
                        v-if="can('Punch labor dtl')"
                        :href="route('cnc.CNCOccupancyRate')"
                        @click="setDepartment('CNC')"
                    >
                        <v-list-item
                            rounded="xl"
                            title="CNC Machine Occupancy Rate"
                            value="CNCOccupancyRate"
                            color="#d9e3f0"
                        ></v-list-item>
                    </Link>
                    <Link
                        v-if="can('Punch labor dtl')"
                        :href="route('CNC.routeCNCSchedule')"
                        @click="setDepartment('CNC')"
                    >
                        <v-list-item
                            rounded="xl"
                            title="CNC Schedule"
                            value="routeCNCSchedule"
                            color="#d9e3f0"
                        ></v-list-item>
                    </Link>
                    <Link
                        v-if="can('Punch labor dtl')"
                        :href="route('hr.labor-dtl')"
                        @click="setDepartment('CNC')"
                    >
                        <v-list-item
                            rounded="xl"
                            title="Employee Punch Detail"
                            value="CNCEmpJobDetail"
                            color="#d9e3f0"
                        ></v-list-item>
                    </Link>
                    <!--                    <Link-->
                    <!--                        v-if="can('Edit labor dtl')"-->
                    <!--                        :href="route('itDepartment-fixEmployeePunch')"-->
                    <!--                    >-->
                    <!--                        <v-list-item-->
                    <!--                            rounded="xl"-->
                    <!--                            title="Fix Employee Punch"-->
                    <!--                            value="CNCFixEmployeePunch"-->
                    <!--                            color="#d9e3f0"-->
                    <!--                        ></v-list-item>-->
                    <!--                    </Link>-->
                    <Link
                        v-if="can('page CNC')"
                        :href="route('project-management')"
                        @click="setDepartment('CNC')"
                    >
                        <v-list-item
                            rounded="xl"
                            title="Project Progress"
                            value="CNCProjectManagement"
                            color="#d9e3f0"
                        ></v-list-item>
                    </Link>
                    <!--                    <Link-->
                    <!--                        v-if="can('page CNC')"-->
                    <!--                        :href="route('cnc.qualityChecklist')"-->
                    <!--                    >-->
                    <!--                        <v-list-item-->
                    <!--                            rounded="xl"-->
                    <!--                            title="CNC Quality Checklist"-->
                    <!--                            value="CNCQualityChecklist"-->
                    <!--                            color="#d9e3f0"-->
                    <!--                        ></v-list-item>-->
                    <!--                    </Link>-->
                    <Link
                        v-if="can('page CNC')"
                        :href="route('cnc.routeCreateCutRequest')"
                        @click="setDepartment('CNC')"
                    >
                        <v-list-item
                            rounded="xl"
                            title="Create Cut Request"
                            value="CreateCutRequest"
                            color="#d9e3f0"
                        ></v-list-item>
                    </Link>
                    <Link
                        v-if="can('page CNC')"
                        :href="route('cnc.cutRequestList')"
                        @click="setDepartment('CNC')"
                    >
                        <v-list-item
                            rounded="xl"
                            title="Cut Request List"
                            value="CutRequestList"
                            color="#d9e3f0"
                        ></v-list-item>
                    </Link>
                    <Link
                        v-if="can('page CNC')"
                        :href="route('cnc.cutRequestHistory')"
                        @click="setDepartment('CNC')"
                    >
                        <v-list-item
                            rounded="xl"
                            title="Cut Request History"
                            value="CutRequestHistory"
                            color="#d9e3f0"
                        ></v-list-item>
                    </Link>

                    <Link
                        v-if="can('page CNC')"
                        :href="route('project-material-yield-generator')"
                        @click="setDepartment('CNC')"
                    >
                        <v-list-item
                            rounded="xl"
                            title="Material Yield"
                            value="CNCMaterialYieldGenerator"
                            color="#d9e3f0"
                        ></v-list-item>
                    </Link>
                    <Link
                        v-if="can('material sheet add')"
                        :href="route('CNC-MaterialForecast')"
                        @click="setDepartment('CNC')"
                    >
                        <v-list-item
                            rounded="xl"
                            title="Material Sheet Forecast"
                            value="CNCMaterialSheetForecast"
                            color="#d9e3f0"
                        ></v-list-item>
                    </Link>
                    <Link
                        v-if="can('page it-department')"
                        :href="route('operations')"
                        @click="setDepartment('CNC')"
                    >
                        <v-list-item
                            rounded="xl"
                            color="#d9e3f0"
                            title="Operations"
                            value="Operations"
                        ></v-list-item>
                    </Link>
                    <!--                    <Link :href="route('project-operation-by-job')">-->
                    <!--                        <v-list-item-->
                    <!--                            rounded="xl"-->
                    <!--                            title="Operation by Job"-->
                    <!--                            color="#d9e3f0"-->
                    <!--                            value="OPEByJob"-->
                    <!--                        ></v-list-item>-->
                    <!--                    </Link>-->
                    <Link
                        v-if="can('page Shift Calendar')"
                        :href="route('CNC-shiftCalendar')"
                        @click="setDepartment('CNC')"
                    >
                        <v-list-item
                            rounded="xl"
                            title="Shift Calendar"
                            value="CNCShiftCalendar"
                            color="#d9e3f0"
                        >
                        </v-list-item>
                    </Link>
                    <Link
                        :href="route('purchasing-supplyRequestDash')"
                        @click="setDepartment('CNC')"
                    >
                        <v-list-item
                            title="Supply Request"
                            rounded="xl"
                            color="#d9e3f0"
                            value="SupplyRequestFormCNC"
                        ></v-list-item>
                    </Link>
                    <Link
                        v-if="can('Add/Edit Tablets and Resources')"
                        :href="route('resourcegroup')"
                        @click="setDepartment('CNC')"
                    >
                        <v-list-item
                            title="Resource Group"
                            value="ResourceGroup"
                            color="#d9e3f0"
                            rounded="xl"
                        ></v-list-item>
                    </Link>
                    <Link
                        v-if="can('Add/Edit Tablets and Resources')"
                        :href="route('reasoncode')"
                        @click="setDepartment('CNC')"
                    >
                        <v-list-item
                            title="Reason Code"
                            value="ReasonCode"
                            color="#d9e3f0"
                            rounded="xl"
                        ></v-list-item>
                    </Link>
                    <Link
                        v-if="can('page CNC')"
                        :href="route('CNC-resourceLinks')"
                        @click="setDepartment('CNC')"
                    >
                        <v-list-item
                            rounded="xl"
                            title="Tablet Resource Links"
                            value="CNCTabletResourceLinks"
                            color="#d9e3f0"
                        ></v-list-item>
                    </Link>
                    <Link
                        v-if="can('Edit labor dtl')"
                        :href="route('hr.time-expense')"
                        @click="setDepartment('CNC')"
                    >
                        <v-list-item
                            rounded="xl"
                            title="Time Expense"
                            value="CNCTimeExpense"
                            color="#d9e3f0"
                        ></v-list-item>
                    </Link>
                    <Link
                        v-if="can('Add Tool Consumption')"
                        :href="route('cnc.ToolConsumption')"
                        @click="setDepartment('CNC')"
                    >
                        <v-list-item
                            rounded="xl"
                            title="Tool Consumption"
                            value="CNCToolConsumption"
                            color="#d9e3f0"
                        ></v-list-item>
                    </Link>
                    <Link
                        v-if="can('Add Tool Consumption')"
                        :href="route('tools-inventory')"
                        @click="setDepartment('CNC')"
                    >
                        <v-list-item
                            rounded="xl"
                            color="#d9e3f0"
                            title="Tools Inventory"
                            value="CNC_ToolsInventory"
                        >
                        </v-list-item>
                    </Link>
                    <Link
                        :href="route('type-edit-usage')"
                        @click="setDepartment('CNC')"
                    >
                        <v-list-item
                            rounded="xl"
                            title="TypeEdit Usage"
                            value="TypeEditUsageCNC"
                            color="#d9e3f0"
                        ></v-list-item>
                    </Link>
                    <Link
                        :href="route('CNC-help')"
                        @click="setDepartment('CNC')"
                    >
                        <v-list-item
                            title="Help"
                            value="CNCHelp"
                            color="#d9e3f0"
                            rounded="xl"
                            append-icon="mdi:mdi-help-circle-outline"
                        ></v-list-item>
                    </Link>
                </v-list-group>

                <!---D3 Resources---->
                <v-list-group
                    color="whitesmoke"
                    value="D3Resources"
                    v-if="this.$page?.props?.auth?.user?.countryCodeFK === 'US'"
                >
                    <template v-slot:activator="{ props }">
                        <v-list-item
                            prepend-icon="mdi:mdi-toolbox"
                            v-bind="props"
                            title="D3 Resources"
                        ></v-list-item>
                    </template>
                    <Link :href="route('itDepartment-logos')">
                        <v-list-item
                            color="#d9e3f0"
                            rounded="xl"
                            value="D3Logos"
                        >
                            <template #title>
                                <span style="white-space: normal">
                                    Logos / Signatures / Wallpapers
                                </span>
                            </template>
                        </v-list-item>
                    </Link>
                    <Link :href="route('photo-list')">
                        <v-list-item
                            rounded="xl"
                            title="Photo List"
                            value="D3Photo-List"
                            color="#d9e3f0"
                        ></v-list-item>
                    </Link>
                    <Link :href="route('project-management-standPartCatalog')">
                        <v-list-item
                            rounded="xl"
                            title="Standard Parts Catalog"
                            value="D3StandardPartCatalog"
                            color="#d9e3f0"
                        ></v-list-item>
                    </Link>
                </v-list-group>

                <!--Decoration / Silkscreen--->
                <v-list-group
                    color="whitesmoke"
                    v-if="can('page SIL')"
                    value="SIL"
                >
                    <template v-slot:activator="{ props }">
                        <v-list-item
                            prepend-icon="mdi:mdi-brush"
                            v-bind="props"
                            title="Decoration"
                        ></v-list-item>
                    </template>
                    <Link
                        :href="route('SIL-opsDash')"
                        @click="setDepartment('SIL')"
                    >
                        <v-list-item
                            rounded="xl"
                            title="Decoration Dashboard"
                            color="#d9e3f0"
                            value="SILOPSDashboard"
                        ></v-list-item>
                    </Link>
                    <!--                    <Link-->
                    <!--                        :href="route('digital-printing-progress')"-->
                    <!--                        v-if="can('decoration job tracker')"-->
                    <!--                    >-->
                    <!--                        <v-list-item-->
                    <!--                            rounded="xl"-->
                    <!--                            title="Decoration Progress"-->
                    <!--                            color="#d9e3f0"-->
                    <!--                            value="SILDecorationProgress"-->
                    <!--                        ></v-list-item>-->
                    <!--                    </Link>-->
                    <Link
                        v-if="can('page digital print requests')"
                        :href="route('digital-printing-request-list')"
                        @click="setDepartment('SIL')"
                    >
                        <v-list-item
                            rounded="xl"
                            title="Digital Printing Requests"
                            color="#d9e3f0"
                            value="DigitalPrintingRequestList"
                        ></v-list-item>
                    </Link>
                    <Link
                       v-if="can('page digital print requests')"
                        :href="route('SIL.routeSILSchedule')"
                        @click="setDepartment('SIL')"
                    >
                        <v-list-item
                            rounded="xl"
                            title="Decoration Schedule"
                            value="routeSILSchedule"
                            color="#d9e3f0"
                        ></v-list-item>
                    </Link>
                    <!-- <Link
                        v-if="can('print estimator')"
                        :href="route('digital-project-efficiency')"
                    >
                        <v-list-item
                            rounded="xl"
                            title="Project Efficiency"
                            value="ProjectEfficiency"
                            color="#d9e3f0"
                        ></v-list-item>
                    </Link> -->
                    <Link
                        v-if="can('page SIL')"
                        :href="route('project-management')"
                        @click="setDepartment('SIL')"
                    >
                        <v-list-item
                            rounded="xl"
                            title="Project Progress"
                            value="SILProjectManagement"
                            color="#d9e3f0"
                        ></v-list-item>
                    </Link>
                    <!--                    <Link-->
                    <!--                        v-if="can('print estimator')"-->
                    <!--                        :href="route('digital-printing-estimator')"-->
                    <!--                    >-->
                    <!--                        <v-list-item-->
                    <!--                            rounded="xl"-->
                    <!--                            title="Print Estimator"-->
                    <!--                            value="PrintEstimator"-->
                    <!--                            color="#d9e3f0"-->
                    <!--                        ></v-list-item>-->
                    <!--                    </Link>-->
                    <Link
                        v-if="can('page Shift Calendar')"
                        :href="route('SIL-shiftCalendar')"
                        @click="setDepartment('SIL')"
                    >
                        <v-list-item
                            rounded="xl"
                            title="Shift Calendar"
                            color="#d9e3f0"
                            value="SILShiftCalendar"
                        >
                        </v-list-item>
                    </Link>
                    <Link
                        :href="route('purchasing-supplyRequestDash')"
                        @click="setDepartment('SIL')"
                    >
                        <v-list-item
                            title="Supply Request"
                            rounded="xl"
                            color="#d9e3f0"
                            value="SupplyRequestFormDEC"
                        ></v-list-item>
                    </Link>
                    <Link
                        :href="route('project-request-material')"
                        @click="setDepartment('SIL')"
                    >
                        <v-list-item
                            rounded="xl"
                            title="Request Material"
                            value="SILRequestMaterial"
                            color="#d9e3f0"
                        ></v-list-item>
                    </Link>
                    <Link
                        :href="route('SIL-resourceLinks')"
                        @click="setDepartment('SIL')"
                    >
                        <v-list-item
                            rounded="xl"
                            title="Tablet Resource Links"
                            value="SILTabletResourceLinks"
                            color="#d9e3f0"
                        ></v-list-item>
                    </Link>
                    <Link
                        :href="route('ASM-help')"
                        @click="setDepartment('SIL')"
                    >
                        <v-list-item
                            title="Help"
                            value="SILHelp"
                            color="#d9e3f0"
                            rounded="xl"
                            append-icon="mdi:mdi-help-circle-outline"
                        ></v-list-item>
                    </Link>
                </v-list-group>

                <!---Design---->
                <v-list-group
                    color="whitesmoke"
                    value="Design"
                    v-if="can('page Design')"
                >
                    <template v-slot:activator="{ props }">
                        <v-list-item
                            prepend-icon="mdi:mdi-palette-outline"
                            v-bind="props"
                            title="Design"
                        ></v-list-item>
                    </template>
                    <Link
                        :href="route('design.instruction-sheets')"
                        v-if="can('BOT test pages')"
                        @click="setDepartment('DSN')"
                    >
                        <v-list-item
                            rounded="xl"
                            title="Instruction Sheets"
                            value="Designinstruction-sheets"
                            color="#d9e3f0"
                        ></v-list-item>
                    </Link>

                    <a href="https://matlabs.diaminter.com/" target="_blank">
                        <v-list-item
                            rounded="xl"
                            title="Matlabs"
                            value="DesignMatlabs"
                            color="#d9e3f0"
                        ></v-list-item>
                    </a>
                    <!-- <Link
                        v-if="can('page Design')"
                        :href="route('design-materials')"
                    >
                        <v-list-item
                            rounded="xl"
                            title="Materials"
                            value="DesignMaterials"
                            color="#d9e3f0"
                        ></v-list-item>
                    </Link> -->

                    <Link
                        :href="route('project-list')"
                        @click="setDepartment('DSN')"
                    >
                        <v-list-item
                            rounded="xl"
                            title="Project List"
                            value="DesignProjectList"
                            color="#d9e3f0"
                        ></v-list-item>
                    </Link>
                    <v-list-group
                        v-if="can('request design')"
                        value="RequestDesign"
                    >
                        <template v-slot:activator="{ props }">
                            <v-list-item
                                v-bind="props"
                                title="Request Design"
                                rounded="xl"
                            ></v-list-item>
                        </template>
                        <Link
                            :href="
                                route(
                                    'project-management.production-graphic-request'
                                )
                            "
                            @click="setDepartment('DSN')"
                        >
                            <v-list-item
                                rounded="xl"
                                title="Production Graphic Request"
                                value="DesignerProductionGraphicRequest"
                                color="#d9e3f0"
                                style="padding-inline-start: 80px !important"
                            ></v-list-item>
                        </Link>
                        <Link
                            :href="
                                route(
                                    'project-management.digital-printing-request'
                                )
                            "
                            @click="setDepartment('DSN')"
                        >
                            <v-list-item
                                rounded="xl"
                                title="Digital Printing Request"
                                value="DesignerDigitalPrintingRequest"
                                color="#d9e3f0"
                                style="padding-inline-start: 80px !important"
                            ></v-list-item>
                        </Link>
                    </v-list-group>
                    <Link
                        v-if="can('page Design Scheduler')"
                        :href="route('design-scheduler')"
                        @click="setDepartment('DSN')"
                    >
                        <v-list-item
                            rounded="xl"
                            title="Scheduler"
                            value="DesignScheduler"
                            color="#d9e3f0"
                        ></v-list-item>
                    </Link>
                    <Link
                        v-if="can('page Design Scheduler')"
                        :href="route('design-schedulerSubtaskList')"
                        @click="setDepartment('DSN')"
                    >
                        <v-list-item
                            rounded="xl"
                            title="Scheduler SubTask"
                            value="DesignSchedulerSubtaskList"
                            color="#d9e3f0"
                        ></v-list-item>
                    </Link>
                </v-list-group>

                <!---Engineering--->
                <v-list-group
                    color="whitesmoke"
                    value="Engineering"
                    v-if="can('page engineering')"
                >
                    <template v-slot:activator="{ props }">
                        <v-list-item
                            prepend-icon="mdi:mdi-cogs"
                            v-bind="props"
                            title="Engineering"
                        ></v-list-item>
                    </template>
                    <Link
                        :href="route('engineering-dashboard')"
                        @click="setDepartment('ENG')"
                    >
                        <v-list-item
                            rounded="xl"
                            title="Engineering Dashboard"
                            value="EngineeringDashboard"
                            color="#d9e3f0"
                        >
                            <!--                            <template v-slot:append>-->
                            <!--                                <span v-if="departmentFK === 'Engineering 20' || departmentFK === 'Engineering 70' || departmentFK === 'Engineering 75'">-->
                            <!--                                    <v-progress-circular-->
                            <!--                                        v-if="loadingPMNotification"-->
                            <!--                                        color="blue"-->
                            <!--                                        size="20"-->
                            <!--                                        indeterminate-->
                            <!--                                    />-->
                            <!--                                    <v-badge-->
                            <!--                                        v-if="-->
                            <!--                                            newRequestCountPM >-->
                            <!--                                                0 && !loadingPMNotification-->
                            <!--                                        "-->
                            <!--                                        :content="-->
                            <!--                                            newRequestCountPM-->
                            <!--                                        "-->
                            <!--                                        color="error"-->
                            <!--                                        inline-->
                            <!--                                    />-->
                            <!--                                </span>-->
                            <!--                            </template>-->
                        </v-list-item>
                    </Link>
                    <Link
                        v-if="can('page engineering')"
                        :href="route('EN-approval')"
                        @click="setDepartment('ENG')"
                    >
                        <v-list-item
                            rounded="xl"
                            title="Approvals"
                            value="ENApprovals"
                            color="#d9e3f0"
                        ></v-list-item>
                    </Link>
                    <Link
                        :href="route('project-code-generator')"
                        @click="setDepartment('ENG')"
                    >
                        <v-list-item
                            rounded="xl"
                            title="Code Generator"
                            value="ENGCodeGenerator"
                            color="#d9e3f0"
                        ></v-list-item>
                    </Link>
                    <Link
                        :href="route('cnc.routeCreateCutRequest')"
                        @click="setDepartment('ENG')"
                    >
                        <v-list-item
                            rounded="xl"
                            title="Create Cut Request"
                            value="ENGCreateCutRequest"
                            color="#d9e3f0"
                        ></v-list-item>
                    </Link>
                    <Link
                        :href="route('cnc.cutRequestList')"
                        @click="setDepartment('ENG')"
                    >
                        <v-list-item
                            rounded="xl"
                            title="Cut Request List"
                            value="ENGCutRequestList"
                            color="#d9e3f0"
                        ></v-list-item>
                    </Link>
                    <Link
                        :href="route('file-dropper')"
                        @click="setDepartment('ENG')"
                    >
                        <v-list-item
                            rounded="xl"
                            title="File Dropper"
                            value="FileDropper"
                            color="#d9e3f0"
                        ></v-list-item>
                    </Link>
                    <Link
                        :href="route('project-material-sheet')"
                        @click="setDepartment('ENG')"
                    >
                        <v-list-item
                            rounded="xl"
                            title="Material Sheet Inventory"
                            value="ENGMaterialSheetInventory"
                            color="#d9e3f0"
                        ></v-list-item>
                    </Link>
                    <Link
                        :href="route('project-material-yield-generator')"
                        @click="setDepartment('ENG')"
                    >
                        <v-list-item
                            rounded="xl"
                            title="Material Yield"
                            value="ENGMaterialYieldGenerator"
                            color="#d9e3f0"
                        ></v-list-item>
                    </Link>
                    <Link
                        :href="route('operations')"
                        @click="setDepartment('ENG')"
                    >
                        <v-list-item
                            rounded="xl"
                            color="#d9e3f0"
                            title="Operations"
                            value="ENGOperations"
                        ></v-list-item>
                    </Link>
                    <Link
                        :href="route('project-list')"
                        @click="setDepartment('ENG')"
                    >
                        <v-list-item
                            rounded="xl"
                            title="Project List"
                            value="ENGProjectList"
                            color="#d9e3f0"
                        ></v-list-item>
                    </Link>
                    <Link
                        :href="route('project-management')"
                        @click="setDepartment('ENG')"
                    >
                        <v-list-item
                            rounded="xl"
                            title="Project Progress"
                            value="ENGProjectManagement"
                            color="#d9e3f0"
                        ></v-list-item>
                    </Link>
                    <Link
                        :href="route('project-request-material')"
                        @click="setDepartment('ENG')"
                    >
                        <v-list-item
                            rounded="xl"
                            title="Request Material"
                            value="ENGRequestMaterial"
                            color="#d9e3f0"
                        ></v-list-item>
                    </Link>
                    <Link
                        :href="route('type-edit-usage')"
                        @click="setDepartment('ENG')"
                    >
                        <v-list-item
                            rounded="xl"
                            title="TypeEdit Usage"
                            value="TypeEditUsage"
                            color="#d9e3f0"
                        ></v-list-item>
                    </Link>
                    <Link
                        :href="route('EN-vacf-approvals')"
                        @click="setDepartment('ENG')"
                    >
                        <v-list-item
                            rounded="xl"
                            title="Purchased Part Approvals"
                            value="ENGVACFApprovals"
                            color="#d9e3f0"
                        ></v-list-item>
                    </Link>
                </v-list-group>

                <!----D3 Facilities---->
                <v-list-group
                    color="whitesmoke"
                    value="Facilities"
                    v-if="this.$page?.props?.auth?.user?.countryCodeFK === 'US'"
                >
                    <template v-slot:activator="{ props }">
                        <v-list-item
                            prepend-icon="mdi:mdi-wrench-clock"
                            v-bind="props"
                            title="Facilities"
                        ></v-list-item>
                    </template>
                    <Link
                        :href="route('maintenance-request')"
                        @click="setDepartment('FAC')"
                    >
                        <v-list-item
                            rounded="xl"
                            title="Maintenance Request"
                            value="MaintenanceRequest"
                            color="#d9e3f0"
                        ></v-list-item>
                    </Link>

                    <Link
                        v-if="can('view maintenance todo')"
                        :href="route('d3-get-oil-use')"
                        @click="setDepartment('FAC')"
                    >
                        <v-list-item
                            rounded="xl"
                            title="Oil Meter"
                            value="OilMeter"
                            color="#d9e3f0"
                        ></v-list-item>
                    </Link>

                    <Link
                        v-if="can('view maintenance todo')"
                        :href="route('to-do-list')"
                        @click="setDepartment('FAC')"
                    >
                        <v-list-item
                            rounded="xl"
                            title="To Do List"
                            value="ToDoList"
                            color="#d9e3f0"
                        ></v-list-item>
                    </Link>
                    <Link
                        v-if="can('page Shift Calendar')"
                        :href="route('MAIN-shiftCalendar')"
                        @click="setDepartment('FAC')"
                    >
                        <v-list-item
                            rounded="xl"
                            title="Shift Calendar"
                            value="MAINShiftCalendar"
                            color="#d9e3f0"
                        >
                        </v-list-item>
                    </Link>
                </v-list-group>

                <!----FINANCE---->
                <v-list-group
                    color="whitesmoke"
                    value="Finance"
                    v-if="can('finance sales tax')"
                >
                    <template v-slot:activator="{ props }">
                        <v-list-item
                            prepend-icon="mdi:mdi-cash-lock"
                            v-bind="props"
                            title="Finance"
                        ></v-list-item>
                    </template>
                    <Link
                        :href="route('finance.d3-stores')"
                        @click="setDepartment('FIN')"
                    >
                        <v-list-item
                            rounded="xl"
                            title="D3 Stores"
                            value="FinanceD3Stores"
                            color="#d9e3f0"
                        ></v-list-item>
                    </Link>
                </v-list-group>

                <!---
                HR MODULE
                DO NOT BLOCK HR WITH CAN(). ALL USERS NEED TO PRINT OUT FORMS
        ONLY BLOCK CERTAIN HR PAGES
        -->
                <v-list-group
                    color="whitesmoke"
                    value="HR"
                    v-if="this.$page?.props?.auth?.user?.countryCodeFK === 'US'"
                >
                    <template v-slot:activator="{ props }">
                        <v-list-item
                            prepend-icon="mdi:mdi-account-group"
                            v-bind="props"
                            title="HR"
                        ></v-list-item>
                    </template>
                    <Link
                        v-if="can('page hr/home')"
                        :href="route('hr.home')"
                        @click="setDepartment('HRD')"
                    >
                        <v-list-item
                            color="#d9e3f0"
                            rounded="xl"
                            title="Home"
                            value="HRHome"
                        ></v-list-item>
                    </Link>
                    <Link
                        v-if="can('page hr/employees')"
                        :href="route('hr.agencies')"
                        @click="setDepartment('HRD')"
                    >
                        <v-list-item
                            rounded="xl"
                            title="Agencies"
                            value="HRAgencies"
                            color="#d9e3f0"
                        ></v-list-item>
                    </Link>
                    <Link
                        v-if="can('page hr/employees')"
                        :href="route('hr.epicor-shifts')"
                        @click="setDepartment('HRD')"
                    >
                        <v-list-item
                            rounded="xl"
                            title="Create Shifts"
                            value="CreateShift"
                            color="#d9e3f0"
                        ></v-list-item>
                    </Link>
                    <Link
                        v-if="can('page hr/employees')"
                        :href="route('hr.epicor-departments')"
                        @click="setDepartment('HRD')"
                    >
                        <v-list-item
                            rounded="xl"
                            title="Departments"
                            value="HRDepartments"
                            color="#d9e3f0"
                        ></v-list-item>
                    </Link>

                    <Link
                        v-if="can('page hr/employees')"
                        :href="route('hr.employees')"
                        @click="setDepartment('HRD')"
                    >
                        <v-list-item
                            rounded="xl"
                            title="Employees"
                            value="Employees"
                            color="#d9e3f0"
                        ></v-list-item>
                    </Link>
                    <Link
                        :href="route('hr.forms')"
                        @click="setDepartment('HRD')"
                    >
                        <v-list-item
                            rounded="xl"
                            title="Forms"
                            value="Forms"
                            color="#d9e3f0"
                        ></v-list-item>
                    </Link>

                    <Link
                        v-if="can('view KPI')"
                        :href="route('management-kpi')"
                        @click="setDepartment('HRD')"
                    >
                        <v-list-item
                            rounded="xl"
                            title="KPI"
                            value="hrKPI"
                            color="#d9e3f0"
                        ></v-list-item>
                    </Link>
                    <Link
                        v-if="can('page hr/labor-dashboard')"
                        :href="route('labor.labor-dashboard')"
                        @click="setDepartment('HRD')"
                    >
                        <v-list-item
                            rounded="xl"
                            title="Labor Dashboard"
                            value="LaborDashboard"
                            color="#d9e3f0"
                        ></v-list-item>
                    </Link>

                    <Link
                        v-if="can('page hr/labor-dashboard')"
                        :href="route('labor.labor-logs')"
                        @click="setDepartment('HRD')"
                    >
                        <v-list-item
                            rounded="xl"
                            title="Labor Logs"
                            value="LaborLogs"
                            color="#d9e3f0"
                        ></v-list-item>
                    </Link>

                    <Link
                        :href="route('hr.sops')"
                        @click="setDepartment('HRD')"
                    >
                        <v-list-item
                            rounded="xl"
                            title="SOPs"
                            value="sops"
                            color="#d9e3f0"
                        ></v-list-item>
                    </Link>

                    <Link
                        v-if="can('page hr/labor-dashboard')"
                        :href="route('hr.punch-system')"
                        @click="setDepartment('HRD')"
                    >
                        <v-list-item
                            rounded="xl"
                            title="Punch Page"
                            value="HRPunchSystem"
                            color="#d9e3f0"
                        ></v-list-item>
                    </Link>
                    <Link
                        :href="route('hr.temp-request-dashboard')"
                        @click="setDepartment('HRD')"
                    >
                        <v-list-item
                            rounded="xl"
                            title="Temp Requests"
                            value="TempRequests"
                            color="#d9e3f0"
                        >
                            <template v-slot:append>
                                <span v-if="can('manage temps')">
                                    <v-progress-circular
                                        v-if="loading"
                                        color="blue"
                                        size="20"
                                        indeterminate
                                    />
                                    <v-badge
                                        v-if="
                                            newRequestCount +
                                                cancelRequestCount >
                                                0 && !loading
                                        "
                                        :content="
                                            newRequestCount + cancelRequestCount
                                        "
                                        color="error"
                                        inline
                                    />
                                </span>
                            </template>
                        </v-list-item>
                    </Link>
                </v-list-group>

                <!-- IT Dept--->
                <v-list-group value="IT Department" color="whitesmoke">
                    <template v-slot:activator="{ props }">
                        <v-list-item
                            prepend-icon="mdi:mdi-lan-connect"
                            v-bind="props"
                            title="IT Department"
                        ></v-list-item>
                    </template>
                    <Link
                        :href="route('itDepartment-downloads')"
                        @click="setDepartment('ITD')"
                    >
                        <v-list-item
                            rounded="xl"
                            title="Downloads"
                            value="Downloads"
                            color="#d9e3f0"
                        ></v-list-item>
                    </Link>
                    <Link
                        v-if="can('page it-department')"
                        :href="route('it.inventory')"
                        @click="setDepartment('ITD')"
                    >
                        <v-list-item
                            rounded="xl"
                            color="#d9e3f0"
                            title="Inventory"
                            value="ItInventory"
                        ></v-list-item>
                    </Link>
                    <Link
                        :href="route('itDepartment-vpn')"
                        @click="setDepartment('ITD')"
                    >
                        <v-list-item
                            rounded="xl"
                            title="How to use the VPN"
                            value="VPN"
                            color="#d9e3f0"
                        ></v-list-item>
                    </Link>
                    <Link
                        :href="route('itDepartment-office')"
                        @click="setDepartment('ITD')"
                    >
                        <v-list-item
                            rounded="xl"
                            title="Office 365 & Email"
                            value="Office365"
                            color="#d9e3f0"
                        >
                        </v-list-item>
                    </Link>
                    <Link
                        :href="route('itDepartment-phoneList')"
                        v-if="can('page Phone List')"
                        @click="setDepartment('ITD')"
                    >
                        <v-list-item
                            rounded="xl"
                            color="#d9e3f0"
                            title="Phone List"
                            value="PhoneList"
                        >
                        </v-list-item>
                    </Link>
                    <Link
                        :href="route('itDepartment-teams')"
                        @click="setDepartment('ITD')"
                    >
                        <v-list-item
                            color="#d9e3f0"
                            rounded="xl"
                            title="Teams Collaboration"
                            value="TeamsCollaboration"
                        >
                        </v-list-item>
                    </Link>
                    <Link
                        :href="route('tv')"
                        v-if="can('page TV List')"
                        @click="setDepartment('ITD')"
                    >
                        <v-list-item
                            rounded="xl"
                            color="#d9e3f0"
                            title="TV & Links"
                            value="TV"
                        ></v-list-item>
                    </Link>
                    <Link
                        :href="route('itDepartment-virtualOffice')"
                        @click="setDepartment('ITD')"
                    >
                        <v-list-item
                            rounded="xl"
                            color="#d9e3f0"
                            title="Virtual Office"
                            value="VirtualOffice"
                        ></v-list-item>
                    </Link>
                    <Link
                        v-if="can('page it-department')"
                        :href="route('itDepartment-patchNotes')"
                        @click="setDepartment('ITD')"
                    >
                        <v-list-item
                            rounded="xl"
                            color="#d9e3f0"
                            title="Patch Notes Form"
                            value="PatchNoteForm"
                        ></v-list-item>
                    </Link>
                    <Link
                        v-if="can('page it-department')"
                        :href="route('itDepartment-testCode')"
                        @click="setDepartment('ITD')"
                    >
                        <v-list-item
                            rounded="xl"
                            color="#d9e3f0"
                            title="Test Code"
                            value="TestCode"
                        ></v-list-item>
                    </Link>
                </v-list-group>

                <!--Logistics-->
                <v-list-group
                    color="whitesmoke"
                    v-if="can('page logistics')"
                    value="Logistics"
                >
                    <template v-slot:activator="{ props }">
                        <v-list-item
                            prepend-icon="mdi:mdi-dolly"
                            v-bind="props"
                            title="Logistics"
                        ></v-list-item>
                    </template>
                    <Link
                        v-if="can('new ship/receive')"
                        :href="route('logistics-b2d')"
                        @click="setDepartment('LOG')"
                    >
                        <v-list-item
                            rounded="xl"
                            title="B2D"
                            value="B2DRoute"
                            color="#d9e3f0"
                        ></v-list-item>
                    </Link>
                    <Link
                        v-if="can('quantity adjustment')"
                        :href="route('quantity-adjustment')"
                        @click="setDepartment('LOG')"
                    >
                        <v-list-item
                            rounded="xl"
                            title="Quantity Adjustment"
                            value="QuantityAdjustment"
                            color="#d9e3f0"
                        ></v-list-item>
                    </Link>
                    <Link
                        :href="route('request-list')"
                        @click="setDepartment('LOG')"
                    >
                        <v-list-item
                            rounded="xl"
                            title="Request List"
                            value="RequestList"
                            color="#d9e3f0"
                        ></v-list-item>
                    </Link>
                    <Link
                        :href="route('move-location')"
                        @click="setDepartment('LOG')"
                    >
                        <v-list-item
                            rounded="xl"
                            title="Move Location"
                            value="MoveLocation"
                            color="#d9e3f0"
                        ></v-list-item>
                    </Link>


                    <Link
                        :href="route('part-tracker')"
                        @click="setDepartment('LOG')"
                    >
                        <v-list-item
                            rounded="xl"
                            title="Part Tracker"
                            value="PartTracker"
                            color="#d9e3f0"
                        ></v-list-item>
                    </Link>
                    <Link
                        :href="route('part-transactions')"
                        @click="setDepartment('LOG')"
                    >
                        <v-list-item
                            rounded="xl"
                            title="Part Transactions"
                            value="PartTransactions"
                            color="#d9e3f0"
                        ></v-list-item>
                    </Link>
                    <Link
                        v-if="can('po receiving')"
                        :href="route('po-receiving')"
                        @click="setDepartment('LOG')"
                    >
                        <v-list-item
                            rounded="xl"
                            title="PO Receiving"
                            color="#d9e3f0"
                            value="POReceiving"
                        ></v-list-item>
                    </Link>

                    <Link
                        v-if="can('new ship/receive')"
                        :href="route('newShip-Receiving')"
                        @click="setDepartment('LOG')"
                    >
                        <v-list-item
                            rounded="xl"
                            title="New Ship/Receiving"
                            value="NewShipAndReceiving"
                            color="#d9e3f0"
                        ></v-list-item>
                    </Link>
                    <Link
                        v-if="can('request material')"
                        :href="route('project-request-material')"
                        @click="setDepartment('LOG')"
                    >
                        <v-list-item
                            rounded="xl"
                            title="Request Material"
                            value="logisticsRequestMaterial"
                            color="#d9e3f0"
                        ></v-list-item>
                    </Link>

                    <Link
                        v-if="can('change priority order')"
                        :href="route('project-management.project-video-dashboard')"
                        @click="setDepartment('LOG')"
                    >
                        <v-list-item
                            rounded="xl"
                            title="Project Video Dashboard"
                            value="logisticsProjectVideoDashboard"
                            color="#d9e3f0"
                        ></v-list-item>
                    </Link>

                    <Link
                        v-if="can('returns inventory')"
                        :href="route('returns-Inventory')"
                        @click="setDepartment('LOG')"
                    >
                        <v-list-item
                            rounded="xl"
                            title="Returns/Inventory"
                            value="ReturnsToInventory"
                            color="#d9e3f0"
                        ></v-list-item>
                    </Link>
                    <Link
                        v-if="can('po receipt entry')"
                        :href="route('purchasing-receiptEntry')"
                        @click="setDepartment('LOG')"
                    >
                        <v-list-item
                            rounded="xl"
                            title="Receipt Entry"
                            value="LOGReceiptEntry"
                            color="#d9e3f0"
                        ></v-list-item>
                    </Link>
                    <Link
                        v-if="can('page Shift Calendar')"
                        :href="route('WHSE-shiftCalendar')"
                        @click="setDepartment('LOG')"
                    >
                        <v-list-item
                            rounded="xl"
                            title="Shift Calendar"
                            value="WHSEShiftCalendar"
                            color="#d9e3f0"
                        >
                        </v-list-item>
                    </Link>
                    <Link
                        v-if="can('po receipt entry')"
                        :href="route('logistics-UPS')"
                        @click="setDepartment('LOG')"
                    >
                        <v-list-item
                            rounded="xl"
                            title="UPS/FedEx Tracker"
                            value="LOCKUPS"
                            color="#d9e3f0"
                        ></v-list-item>
                    </Link>
                    <Link
                        v-if="can('po receipt entry')"
                        :href="route('UPS-worldship')"
                        @click="setDepartment('LOG')"
                    >
                        <v-list-item
                            rounded="xl"
                            title="UPS World Ship"
                            value="UPSWorldShip"
                            color="#d9e3f0"
                        ></v-list-item>
                    </Link>
                    <Link
                        v-if="can('request material')"
                        :href="route('purchasing-supplyRequestDash')"
                        @click="setDepartment('LOG')"
                    >
                        <v-list-item
                            title="Supply Request"
                            rounded="xl"
                            color="#d9e3f0"
                            value="SupplyRequestFormLOG"
                        ></v-list-item>
                    </Link>
                    <Link
                        v-if="can('Add/Edit Tablets and Resources')"
                        :href="route('warehouse')"
                        @click="setDepartment('LOG')"
                    >
                        <v-list-item
                            title="Warehouse"
                            value="Warehouse"
                            color="#d9e3f0"
                            rounded="xl"
                        ></v-list-item>
                    </Link>

                    <Link
                        :href="route('warehouse-inventory')"
                        @click="setDepartment('LOG')"
                    >
                        <v-list-item
                            title="Warehouse Inventory"
                            value="WarehouseInventory"
                            color="#d9e3f0"
                            rounded="xl"
                        ></v-list-item>
                    </Link>
                    <Link
                        :href="route('ztruck-inv')"
                        @click="setDepartment('LOG')"
                    >
                        <v-list-item
                            rounded="xl"
                            title="Z-Truck"
                            value="ZTruck"
                            color="#d9e3f0"
                        ></v-list-item>
                    </Link>
                    <Link
                        :href="route('logistics-help')"
                        @click="setDepartment('LOG')"
                    >
                        <v-list-item
                            title="Help"
                            value="LogisticsHelp"
                            color="#d9e3f0"
                            rounded="xl"
                            append-icon="mdi:mdi-help-circle-outline"
                        ></v-list-item>
                    </Link>
                </v-list-group>

                <!--New Stores--->
                <v-list-group
                    color="whitesmoke"
                    value="NewStores"
                    v-if="can('page new stores')"
                >
                    <template v-slot:activator="{ props }">
                        <v-list-item
                            prepend-icon="mdi:mdi-store-plus"
                            v-bind="props"
                            title="New Stores"
                        ></v-list-item>
                    </template>

                    <Link
                        :href="route('project-code-generator')"
                        @click="setDepartment('NST')"
                    >
                        <v-list-item
                            rounded="xl"
                            title="Code Generator"
                            value="NSCodeGenerator"
                            color="#d9e3f0"
                        ></v-list-item>
                    </Link>

                    <Link
                        :href="route('new-stores-dashboard')"
                        @click="setDepartment('NST')"
                    >
                        <v-list-item
                            rounded="xl"
                            title="New Stores Dashboard"
                            value="NewStoresDashboard"
                            color="#d9e3f0"
                        ></v-list-item>
                    </Link>

                    <Link
                        :href="route('project-management.partInventory')"
                        @click="setDepartment('NST')"
                    >
                        <v-list-item
                            rounded="xl"
                            title="Part Inventory"
                            value="NSPartInventory"
                            color="#d9e3f0"
                        ></v-list-item>
                    </Link>

                    <Link
                        :href="route('project-management-epicorPartRoute')"
                        @click="setDepartment('NST')"
                    >
                        <v-list-item
                            rounded="xl"
                            title="Part Number Creation"
                            value="NSProjectPart"
                            color="#d9e3f0"
                        ></v-list-item>
                    </Link>

                    <Link
                        :href="route('project-request-material')"
                        @click="setDepartment('NST')"
                    >
                        <v-list-item
                            rounded="xl"
                            title="Request Material"
                            color="#d9e3f0"
                            value="NSRequestMaterial"
                        ></v-list-item>
                    </Link>

                    <Link
                        v-if="can('page Shift Calendar')"
                        :href="route('NS-shiftCalendar')"
                        @click="setDepartment('NST')"
                    >
                        <v-list-item
                            rounded="xl"
                            title="Shift Calendar"
                            value="NSShiftCalendar"
                            color="#d9e3f0"
                        >
                        </v-list-item>
                    </Link>
                    <Link
                        :href="route('purchasing-supplyRequestDash')"
                        @click="setDepartment('NST')"
                    >
                        <v-list-item
                            title="Supply Request"
                            rounded="xl"
                            color="#d9e3f0"
                            value="SupplyRequestFormNS"
                        ></v-list-item>
                    </Link>
                    <Link
                        :href="route('project-management-standPartCatalog')"
                        @click="setDepartment('NST')"
                    >
                        <v-list-item
                            rounded="xl"
                            title="Standard Parts Catalog"
                            value="NSStandardPartCatalog"
                            color="#d9e3f0"
                        ></v-list-item>
                    </Link>
                    <Link
                        :href="route('new-stores-watch-list')"
                        @click="setDepartment('NST')"
                    >
                        <v-list-item
                            rounded="xl"
                            title="Watch List"
                            value="WatchList"
                            color="#d9e3f0"
                        ></v-list-item>
                    </Link>
                </v-list-group>

                <!---PRODUCTION--->
                <v-list-group
                    color="whitesmoke"
                    v-if="can('page Production')"
                    value="Production"
                >
                    <template v-slot:activator="{ props }">
                        <v-list-item
                            prepend-icon="mdi:mdi-hammer-wrench"
                            v-bind="props"
                            title="Production"
                        ></v-list-item>
                    </template>
                    <Link
                        :href="route('ALL-opsDash')"
                        @click="setDepartment('PRD')"
                    >
                        <v-list-item
                            rounded="xl"
                            title="Operations Dashboard"
                            value="ProdOPSDashboard"
                            color="#d9e3f0"
                        ></v-list-item>
                    </Link>
                    <Link
                        :href="route('project-list')"
                        @click="setDepartment('PRD')"
                    >
                        <v-list-item
                            rounded="xl"
                            title="Project List"
                            value="ProdProjectList"
                            color="#d9e3f0"
                        ></v-list-item>
                    </Link>
                    <Link
                        :href="route('project-management')"
                        @click="setDepartment('PRD')"
                    >
                        <v-list-item
                            rounded="xl"
                            title="Project Progress"
                            value="ProdProjectManagement"
                            color="#d9e3f0"
                        ></v-list-item>
                    </Link>

                    <Link
                        :href="route('purchasing-supplyRequestDash')"
                        @click="setDepartment('PRD')"
                    >
                        <v-list-item
                            title="Supply Request"
                            rounded="xl"
                            color="#d9e3f0"
                            value="SupplyRequestFormPROD"
                        ></v-list-item>
                    </Link>
                </v-list-group>

                <!---Project management---->
                <v-list-group
                    color="whitesmoke"
                    v-if="can('page project-management/project-progress')"
                    value="Project Management"
                >
                    <template v-slot:activator="{ props }">
                        <v-list-item
                            prepend-icon="mdi:mdi-chart-box-outline"
                            v-bind="props"
                            title="Project Management"
                        ></v-list-item>
                    </template>
                    <Link
                        v-if="can('page project-management/project-progress')"
                        :href="route('project-management-dashboard')"
                        @click="setDepartment('PMT')"
                    >
                        <v-list-item
                            rounded="xl"
                            title="PM Dashboard"
                            value="ProjectManagmentDashboard"
                            color="#d9e3f0"
                        ></v-list-item>
                    </Link>
                    <Link
                        v-if="can('page project-management/project-progress')"
                        :href="route('PM-approval')"
                        @click="setDepartment('PMT')"
                    >
                        <v-list-item
                            rounded="xl"
                            title="Approvals"
                            value="PMApprovals"
                            color="#d9e3f0"
                        ></v-list-item>
                    </Link>

                    <Link
                        v-if="can('page project-management/project-progress')"
                        :href="route('project-bom-duplicator')"
                        @click="setDepartment('PMT')"
                    >
                        <v-list-item
                            rounded="xl"
                            title="BOM Duplicator"
                            value="BomDuplicator"
                            color="#d9e3f0"
                        ></v-list-item>
                    </Link>
                    <Link
                        v-if="can('page project-management/project-progress')"
                        :href="route('project-code-generator')"
                        @click="setDepartment('PMT')"
                    >
                        <v-list-item
                            rounded="xl"
                            title="Code Generator"
                            value="CodeGenerator"
                            color="#d9e3f0"
                        ></v-list-item>
                    </Link>
                    <Link
                        v-if="
                            can('page project-management/engineering workbench')
                        "
                        :href="route('project-management.engineer-work-bench')"
                        @click="setDepartment('PMT')"
                    >
                        <v-list-item
                            rounded="xl"
                            title="Engineering Workbench"
                            value="EngineeringWorkbench"
                            color="#d9e3f0"
                        ></v-list-item>
                    </Link>

                    <Link
                        v-if="can('page project-management/job entry')"
                        :href="route('project-management.job-entry')"
                        @click="setDepartment('PMT')"
                    >
                        <v-list-item
                            rounded="xl"
                            title="Job Entry"
                            value="PMJOBENTRY"
                            color="#d9e3f0"
                        ></v-list-item>
                    </Link>

                    <Link
                        v-if="can('page project-management/project-progress')"
                        :href="route('project-material-yield-generator')"
                        @click="setDepartment('PMT')"
                    >
                        <v-list-item
                            rounded="xl"
                            title="Material Yield"
                            value="MaterialYieldGenerator"
                            color="#d9e3f0"
                        ></v-list-item>
                    </Link>
                    <Link
                        v-if="can('page project-management/project-progress')"
                        :href="route('project-material-sheet')"
                        @click="setDepartment('PMT')"
                    >
                        <v-list-item
                            rounded="xl"
                            title="Material Sheet Inventory"
                            value="MaterialSheetInventory"
                            color="#d9e3f0"
                        ></v-list-item>
                    </Link>

                    <Link
                        :href="route('project-management-epicorPartRoute')"
                        v-if="can('page project-management/project-progress')"
                        @click="setDepartment('PMT')"
                    >
                        <v-list-item
                            rounded="xl"
                            title="Part Number Creation"
                            value="PMProjectPart"
                            color="#d9e3f0"
                        ></v-list-item>
                    </Link>

                    <Link
                        :href="route('project-management.part-transactions')"
                        v-if="can('page project-management/project-progress')"
                        @click="setDepartment('PMT')"
                    >
                        <v-list-item
                            rounded="xl"
                            title="Part Transactions"
                            value="PMPartTransactions"
                            color="#d9e3f0"
                        ></v-list-item>
                    </Link>

                    <Link
                        v-if="can('page project-management/project-progress')"
                        :href="route('pm-projectJobsRoute')"
                        @click="setDepartment('PMT')"
                    >
                        <v-list-item
                            rounded="xl"
                            title="Project Jobs"
                            value="PrjJobs"
                            color="#d9e3f0"
                        ></v-list-item>
                    </Link>

                    <Link
                        v-if="can('page project-management/project-progress')"
                        :href="route('project-list')"
                        @click="setDepartment('PMT')"
                    >
                        <v-list-item
                            rounded="xl"
                            title="Project List"
                            value="ProjectList"
                            color="#d9e3f0"
                        ></v-list-item>
                    </Link>
                    <Link
                        v-if="can('page project-management/project-progress')"
                        :href="route('project-management')"
                        @click="setDepartment('PMT')"
                    >
                        <v-list-item
                            rounded="xl"
                            title="Project Progress"
                            value="ProjectManagement"
                            color="#d9e3f0"
                        ></v-list-item>
                    </Link>
                    <Link
                        v-if="can('page project-management/project-progress')"
                        :href="route('purchasing-advisorRoute')"
                        @click="setDepartment('PMT')"
                    >
                        <v-list-item
                            rounded="xl"
                            title="Purchasing Advisor"
                            value="PMPurchasingAdvisor"
                            color="#d9e3f0"
                        ></v-list-item>
                    </Link>
                    <v-list-group value="PM_RequestDesign">
                        <template v-slot:activator="{ props }">
                            <v-list-item
                                v-bind="props"
                                title="Request Design"
                                rounded="xl"
                            ></v-list-item>
                        </template>
                        <Link
                            :href="
                                route(
                                    'project-management.production-graphic-request'
                                )
                            "
                            @click="setDepartment('PMT')"
                        >
                            <v-list-item
                                rounded="xl"
                                title="Production Graphic Request"
                                value="ProductionGraphicRequest"
                                color="#d9e3f0"
                                style="padding-inline-start: 80px !important"
                            ></v-list-item>
                        </Link>
                        <Link
                            :href="
                                route(
                                    'project-management.digital-printing-request'
                                )
                            "
                            @click="setDepartment('PMT')"
                        >
                            <v-list-item
                                rounded="xl"
                                title="Digital Printing Request"
                                value="DigitalPrintingRequest"
                                color="#d9e3f0"
                                style="padding-inline-start: 80px !important"
                            ></v-list-item>
                        </Link>
                    </v-list-group>
                    <Link
                        v-if="can('page project-management/project-progress')"
                        :href="route('project-request-material')"
                        @click="setDepartment('PMT')"
                    >
                        <v-list-item
                            rounded="xl"
                            title="Request Material"
                            value="RequestMaterial"
                            color="#d9e3f0"
                        ></v-list-item>
                    </Link>

                    <Link
                        :href="route('project-management.qr-code-generator')"
                        @click="setDepartment('PMT')"
                    >
                        <v-list-item
                            rounded="xl"
                            title="QR Code Generator"
                            value="QRCodeGenerator"
                            color="#d9e3f0"
                        ></v-list-item>
                    </Link>

                    <Link
                        v-if="can('page project-management/project-progress')"
                        :href="route('pm-partTimePhase')"
                        @click="setDepartment('PMT')"
                    >
                        <v-list-item
                            rounded="xl"
                            title="Time Phase"
                            color="#d9e3f0"
                            value="PMAssociatedJobsPart"
                        ></v-list-item>
                    </Link>

                    <Link
                        v-if="can('Ulta')"
                        :href="route('project-management.ultaFile')"
                        @click="setDepartment('PMT')"
                    >
                        <v-list-item
                            rounded="xl"
                            title="Ulta Files"
                            color="#d9e3f0"
                            value="UltaFiles"
                        ></v-list-item>
                    </Link>

                    <Link
                        v-if="can('page project-management/project-progress')"
                        :href="route('PM-watch-list')"
                        @click="setDepartment('PMT')"
                    >
                        <v-list-item
                            rounded="xl"
                            title="Watch List"
                            value="PMWatchList"
                            color="#d9e3f0"
                        ></v-list-item>
                    </Link>

                    <Link
                        :href="route('warehouse-inventory')"
                        @click="setDepartment('PMT')"
                    >
                        <v-list-item
                            title="Warehouse Inventory"
                            value="PMWarehouseInventory"
                            color="#d9e3f0"
                            rounded="xl"
                        ></v-list-item>
                    </Link>

                    <Link
                        :href="route('PM-help')"
                        @click="setDepartment('PMT')"
                    >
                        <v-list-item
                            title="Help"
                            value="help"
                            color="#d9e3f0"
                            rounded="xl"
                            append-icon="mdi:mdi-help-circle-outline"
                        ></v-list-item>
                    </Link>
                </v-list-group>

                <!--Purchasing--->
                <v-list-group
                    color="whitesmoke"
                    v-if="can('page purchasing')"
                    value="PUR"
                >
                    <template v-slot:activator="{ props }">
                        <v-list-item
                            prepend-icon="mdi:mdi-cash-lock"
                            v-bind="props"
                            title="Purchasing Dept."
                        ></v-list-item>
                    </template>
                    <v-list-group value="PurchasingDash" class="innerGroup">
                        <template v-slot:activator="{ props }">
                            <v-list-item
                                v-bind="props"
                                title="Purchasing"
                            ></v-list-item>
                        </template>

                        <Link
                            v-if="can('page purchasing')"
                            :href="route('purchasing-dashboard')"
                            @click="setDepartment('PUR')"
                        >
                            <v-list-item
                                rounded="xl"
                                title="Dashboard"
                                value="PurchasingDashboard"
                                color="#d9e3f0"
                            ></v-list-item>
                        </Link>
                        <Link
                            v-if="can('create/edit po agents')"
                            :href="route('purchasing-poAgentRoute')"
                            @click="setDepartment('PUR')"
                        >
                            <v-list-item
                                rounded="xl"
                                title="Buyer"
                                color="#d9e3f0"
                                value="POAgent"
                            ></v-list-item>
                        </Link>
                        <Link
                            :href="route('purchasing-supplyRequestDash')"
                            @click="setDepartment('PUR')"
                        >
                            <v-list-item
                                title="Supply Request"
                                rounded="xl"
                                color="#d9e3f0"
                                value="SupplyRequestForm"
                            >
                                <template v-slot:append>
                                    <span v-if="can('create po')">
                                        <v-progress-circular
                                            v-if="loading"
                                            color="blue"
                                            size="20"
                                            indeterminate
                                        />
                                        <v-badge
                                            v-if="
                                                supplyRequestsCount > 0 &&
                                                !supplyLoading
                                            "
                                            :content="supplyRequestsCount"
                                            color="error"
                                            inline
                                        />
                                    </span> </template
                            ></v-list-item>
                        </Link>
                        <Link
                            v-if="can('view po management')"
                            :href="route('uom')"
                            @click="setDepartment('PUR')"
                        >
                            <v-list-item
                                title="UOM"
                                rounded="xl"
                                color="#d9e3f0"
                                value="UOM"
                            ></v-list-item>
                        </Link>
                        <Link
                            v-if="can('view po management')"
                            :href="route('uomclass')"
                            @click="setDepartment('PUR')"
                        >
                            <v-list-item
                                title="UOM Class"
                                value="UOMClass"
                                rounded="xl"
                                color="#d9e3f0"
                            ></v-list-item>
                        </Link>
                        <Link :href="route('PUR-vacf-approvals')">
                        <v-list-item
                            rounded="xl"
                            title="Purchased Part Approvals"
                            value="PURVACFApprovals"
                            color="#d9e3f0"
                        ></v-list-item>
                    </Link>
                          <Link :href="route('tooling-quote')">
                        <v-list-item
                            rounded="xl"
                            title="Tooling Quotes"
                            value="ToolingQuote"
                            color="#d9e3f0"
                        ></v-list-item>
                    </Link>

                    </v-list-group>
                    <v-list-group class="innerGroup" value="POPurchaseOrder">
                        <template v-slot:activator="{ props }">
                            <v-list-item
                                v-bind="props"
                                title="Purchase Order"
                            ></v-list-item>
                        </template>
                        <Link
                            v-if="can('page purchasing')"
                            :href="route('purchasing-table')"
                            @click="setDepartment('PUR')"
                        >
                            <v-list-item
                                rounded="xl"
                                title="All POs"
                                value="ALLPOPurchasing"
                                color="#d9e3f0"
                            ></v-list-item>
                        </Link>
                        <Link
                            v-if="can('page purchasing')"
                            :href="route('purchasing-rmatable')"
                            @click="setDepartment('PUR')"
                        >
                            <v-list-item
                                rounded="xl"
                                title="All RMAs"
                                color="#d9e3f0"
                                value="ALLRMAPurchasing"
                            ></v-list-item>
                        </Link>
                        <Link
                            v-if="can('page purchasing')"
                            :href="route('purchasing-advisorRoute')"
                            @click="setDepartment('PUR')"
                        >
                            <v-list-item
                                rounded="xl"
                                title="Purchasing Advisor"
                                value="PurchasingAdvisor"
                                color="#d9e3f0"
                            ></v-list-item>
                        </Link>
                        <Link
                            v-if="can('page purchasing')"
                            :href="route('purchased-order-entry')"
                            @click="setDepartment('PUR')"
                        >
                            <v-list-item
                                rounded="xl"
                                title="Purchased Order Entry"
                                color="#d9e3f0"
                                value="PurchaseOrderEntry"
                            >
                            </v-list-item>
                        </Link>
                        <Link
                            v-if="can('page purchasing')"
                            :href="route('purchasing-suggestions')"
                            @click="setDepartment('PUR')"
                        >
                            <v-list-item
                                rounded="xl"
                                title="New PO Suggestions"
                                color="#d9e3f0"
                                value="PurchasingSuggestions"
                            ></v-list-item>
                        </Link>
                        <Link
                            v-if="can('page purchasing')"
                            :href="route('pm-partTimePhase')"
                            @click="setDepartment('PUR')"
                        >
                            <v-list-item
                                rounded="xl"
                                title="Time Phase"
                                color="#d9e3f0"
                                value="POAssociatedJobsPart"
                            ></v-list-item>
                        </Link>
                    </v-list-group>
                    <v-list-group class="innerGroup" value="POProjectsView">
                        <template v-slot:activator="{ props }">
                            <v-list-item
                                v-bind="props"
                                title="Project"
                            ></v-list-item>
                        </template>
                        <Link
                            v-if="can('page purchasing')"
                            :href="route('project-code-generator')"
                            @click="setDepartment('PUR')"
                        >
                            <v-list-item
                                rounded="xl"
                                title="Code Generator"
                                value="PurchasingCodeGenerator"
                                color="#d9e3f0"
                            >
                                <template v-slot:append>
                                    <span
                                        v-if="can('edit/delete tool inventory')"
                                    >
                                        <v-progress-circular
                                            v-if="loading"
                                            color="blue"
                                            size="20"
                                            indeterminate
                                        />
                                        <v-badge
                                            v-if="
                                                approvalCount > 0 &&
                                                !supplyLoading
                                            "
                                            :content="approvalCount"
                                            color="error"
                                            inline
                                        />
                                    </span>
                                </template>
                            </v-list-item>
                        </Link>
                        <Link
                            :href="route('project-management-epicorPartRoute')"
                            @click="setDepartment('PUR')"
                        >
                            <v-list-item
                                rounded="xl"
                                title="Part Number Creation"
                                value="PurchasingProjectPart"
                                color="#d9e3f0"
                            ></v-list-item>
                        </Link>
                        <Link
                            v-if="can('page purchasing')"
                            :href="route('project-list')"
                            @click="setDepartment('PUR')"
                        >
                            <v-list-item
                                rounded="xl"
                                title="Project List"
                                value="PurchasingProjectList"
                                color="#d9e3f0"
                            ></v-list-item>
                        </Link>
                        <Link
                            v-if="can('page purchasing')"
                            :href="route('project-management')"
                            @click="setDepartment('PUR')"
                        >
                            <v-list-item
                                rounded="xl"
                                title="Project Progress"
                                value="PurchasingProjectProgress"
                                color="#d9e3f0"
                            ></v-list-item>
                        </Link>
                    </v-list-group>
                    <v-list-group class="innerGroup" value="POLogistics">
                        <template v-slot:activator="{ props }">
                            <v-list-item
                                v-bind="props"
                                title="Logistics"
                            ></v-list-item>
                        </template>
                        <Link
                            :href="route('part-transactions')"
                            @click="setDepartment('PUR')"
                        >
                            <v-list-item
                                rounded="xl"
                                title="Part Transactions"
                                value="POPartTransactions"
                                color="#d9e3f0"
                            ></v-list-item>
                        </Link>
                        <Link
                            v-if="can('po receipt entry')"
                            :href="route('purchasing-receiptEntry')"
                            @click="setDepartment('PUR')"
                        >
                            <v-list-item
                                rounded="xl"
                                title="Receipt Entry"
                                value="PURReceiptEntry"
                                color="#d9e3f0"
                            ></v-list-item>
                        </Link>
                        <Link
                            v-if="can('page purchasing')"
                            :href="route('project-request-material')"
                            @click="setDepartment('PUR')"
                        >
                            <v-list-item
                                rounded="xl"
                                title="Request Material"
                                value="PurchasingRequestMaterial"
                                color="#d9e3f0"
                            ></v-list-item>
                        </Link>
                    </v-list-group>
                    <v-list-group class="innerGroup" value="POSuppliers">
                        <template v-slot:activator="{ props }">
                            <v-list-item
                                v-bind="props"
                                title="Supplier"
                            ></v-list-item>
                        </template>

                        <Link
                            v-if="can('manage financials')"
                            :href="route('purchasing-supplierFollowUp')"
                            @click="setDepartment('PUR')"
                        >
                            <v-list-item
                                rounded="xl"
                                title="Supplier Follow Up (Details)"
                                value="supplierFollowUp"
                                color="#d9e3f0"
                            ></v-list-item>
                        </Link>

                        <Link
                            v-if="can('manage financials')"
                            :href="route('purchasing-vendorFollowUp')"
                            @click="setDepartment('PUR')"
                        >
                            <v-list-item
                                rounded="xl"
                                title="Supplier Follow Up (Synthetic)"
                                value="vendorFollowUp"
                                color="#d9e3f0"
                            ></v-list-item>
                        </Link>
                        <Link
                            :href="route('purchasing-vendors')"
                            @click="setDepartment('PUR')"
                        >
                            <v-list-item
                                rounded="xl"
                                title="Vendors List"
                                color="#d9e3f0"
                                value="PVendors"
                            ></v-list-item>
                        </Link>
                    </v-list-group>
                    <v-list-group class="innerGroup" value="PORAWMAT">
                        <template v-slot:activator="{ props }">
                            <v-list-item
                                v-bind="props"
                                title="Raw Material"
                            ></v-list-item>
                        </template>
                        <Link
                            :href="route('cnc.materialInventory')"
                            @click="setDepartment('PUR')"
                        >
                            <v-list-item
                                rounded="xl"
                                value="MaterialInventory"
                                color="#d9e3f0"
                            >
                                <v-list-item-title>
                                    Material Inventory<br />(75/20)
                                </v-list-item-title>
                            </v-list-item>
                        </Link>
                        <Link
                            :href="route('project-material-sheet')"
                            @click="setDepartment('PUR')"
                        >
                            <v-list-item
                                rounded="xl"
                                title="Material Sheet Inventory"
                                value="PurchasingMaterialSheetInventory"
                                color="#d9e3f0"
                            ></v-list-item>
                        </Link>
                    </v-list-group>

                    <v-list-group class="innerGroup" value="POCNC">
                        <template v-slot:activator="{ props }">
                            <v-list-item
                                v-bind="props"
                                title="CNC"
                            ></v-list-item>
                        </template>

                        <Link
                            :href="route('tools-inventory')"
                            @click="setDepartment('PUR')"
                        >
                            <v-list-item
                                rounded="xl"
                                color="#d9e3f0"
                                title="Tools Inventory"
                                value="ToolsInventory"
                            >
                            </v-list-item>
                        </Link>
                    </v-list-group>
                    <Link
                        :href="route('purchasing-help')"
                        @click="setDepartment('PUR')"
                    >
                        <v-list-item
                            style="margin-left: -35px"
                            title="Help"
                            value="PurchasingHelp"
                            color="#d9e3f0"
                            rounded="xl"
                        >
                            <template v-slot:append>
                                <v-icon
                                    style="margin-right: -35px"
                                    icon="mdi:mdi-help-circle-outline"
                                ></v-icon>
                            </template>
                        </v-list-item>
                    </Link>
                </v-list-group>

                <!--Punch System DBR--->
                <!-- <v-list-group
                    v-if="can('page punch BR')"
                    color="whitesmoke"
                    value="DbrPunch"
                >
                    <template v-slot:activator="{ props }">
                        <v-list-item
                            prepend-icon="mdi:mdi-calendar-clock"
                            v-bind="props"
                            title="Punch System DBR"
                        ></v-list-item>
                    </template>

                    <Link :href="route('active-jobs-DBR')">
                        <v-list-item
                            rounded="xl"
                            title="Active Jobs"
                            value="ActiveJobsDbr"
                            color="#d9e3f0"
                        ></v-list-item>
                    </Link>
                    <Link :href="route('employees-DBR')">
                        <v-list-item
                            rounded="xl"
                            title="Employees"
                            value="EmployeesDbr"
                            color="#d9e3f0"
                        ></v-list-item>
                    </Link>
                    <Link :href="route('labor-logs-DBR')">
                        <v-list-item
                            rounded="xl"
                            title="Labor Logs"
                            value="LaborLogsDbr"
                            color="#d9e3f0"
                        ></v-list-item>
                    </Link>
                    <Link :href="route('projects-DBR')">
                        <v-list-item
                            rounded="xl"
                            title="Projects"
                            value="ProjectsDbr"
                            color="#d9e3f0"
                        ></v-list-item>
                    </Link>
                    <Link :href="route('log-in-punch-DBR')">
                        <v-list-item
                            rounded="xl"
                            title="Punch System Link"
                            value="DBR"
                            color="indigo-darken-1"
                        ></v-list-item>
                    </Link>
                </v-list-group> -->

                <!--Punch System DMX--->
                <v-list-item
                    prepend-icon="mdi:mdi-calendar-clock"
                    v-if="can('page punch MX')"
                    href="https://dmxconnect.d3llc.org/login"
                    rounded="xl"
                    color="#d9e3f0"
                    title="Punch System DMX"
                ></v-list-item>
                <!-- <v-list-group
                    v-if="can('page punch MX')"
                    color="whitesmoke"
                    value="DmxPunch"
                >
                    <template v-slot:activator="{ props }">
                        <v-list-item
                            prepend-icon="mdi:mdi-calendar-clock"
                            v-bind="props"
                            title="Punch System DMX"
                        ></v-list-item>
                    </template>

                    <Link :href="route('active-jobs-DMX')">
                        <v-list-item
                            rounded="xl"
                            title="Active Jobs"
                            value="ActiveJobsDmx"
                            color="#d9e3f0"
                        ></v-list-item>
                    </Link>
                    <Link :href="route('employees-DMX')">
                        <v-list-item
                            rounded="xl"
                            title="Employees"
                            value="EmployeesDmx"
                            color="#d9e3f0"
                        ></v-list-item>
                    </Link>
                    <Link :href="route('labor-logs-DMX')">
                        <v-list-item
                            rounded="xl"
                            title="Labor Logs"
                            value="LaborLogsDmx"
                            color="#d9e3f0"
                        ></v-list-item>
                    </Link>
                    <Link :href="route('projects-DMX')">
                        <v-list-item
                            rounded="xl"
                            title="Projects"
                            value="ProjectsDmx"
                            color="#d9e3f0"
                        ></v-list-item>
                    </Link>
                    <Link :href="route('log-in-punch-DMX')">
                        <v-list-item
                            rounded="xl"
                            title="Punch System Link"
                            value="DMX"
                            color="indigo-darken-1"
                        ></v-list-item>
                    </Link>
                </v-list-group> -->

                <!---SAFETY--->
                <v-list-group color="whitesmoke" value="Safety">
                    <template v-slot:activator="{ props }">
                        <v-list-item
                            prepend-icon="mdi:mdi-seatbelt"
                            v-bind="props"
                            title="Safety"
                        ></v-list-item>
                    </template>
                    <Link
                        :href="route('accident-dashboard')"
                        v-if="can('add/edit training')"
                        @click="setDepartment('SAF')"
                    >
                        <v-list-item
                            rounded="xl"
                            title="Accident Dashboard"
                            color="#d9e3f0"
                            value="AccidentDashboard"
                        ></v-list-item>
                    </Link>
                    <Link
                        :href="route('photo-list')"
                        @click="setDepartment('SAF')"
                    >
                        <v-list-item
                            rounded="xl"
                            title="Photo List"
                            value="Photo-List"
                            color="#d9e3f0"
                        ></v-list-item>
                    </Link>
                    <Link
                        :href="route('report-accident')"
                        @click="setDepartment('SAF')"
                    >
                        <v-list-item
                            rounded="xl"
                            title="Report Accident"
                            color="#d9e3f0"
                            value="ReportAccident"
                        ></v-list-item>
                    </Link>
                    <Link
                        :href="route('safety-policies')"
                        @click="setDepartment('SAF')"
                    >
                        <v-list-item
                            rounded="xl"
                            title="Safety Policies"
                            color="#d9e3f0"
                            value="SafetyPolicies"
                        ></v-list-item>
                    </Link>

                    <Link
                        :href="route('safety-videos')"
                        @click="setDepartment('SAF')"
                    >
                        <v-list-item
                            rounded="xl"
                            title="Safety Videos"
                            color="#d9e3f0"
                            value="Safety-Videos"
                        ></v-list-item>
                    </Link>

                    <Link
                        :href="route('safety-data-sheets')"
                        @click="setDepartment('SAF')"
                    >
                        <v-list-item
                            rounded="xl"
                            title="Safety Data Sheets"
                            value="SafetyDataSheets"
                            color="#d9e3f0"
                        ></v-list-item>
                    </Link>

                    <Link
                        :href="route('training-dashboard')"
                        v-if="can('add/edit training')"
                        @click="setDepartment('SAF')"
                    >
                        <v-list-item
                            rounded="xl"
                            title="Training Dashboard"
                            value="Training-Dashboard"
                            color="#d9e3f0"
                        ></v-list-item>
                    </Link>
                </v-list-group>

                <!----SALES---->
                <v-list-group
                    color="whitesmoke"
                    v-if="can('page Sales')"
                    value="Sales"
                >
                    <template v-slot:activator="{ props }">
                        <v-list-item
                            prepend-icon="mdi:mdi-format-list-bulleted"
                            v-bind="props"
                            title="Sales"
                        ></v-list-item>
                    </template>
                    <Link
                        :href="route('client-list')"
                        @click="setDepartment('SAL')"
                    >
                        <v-list-item
                            rounded="xl"
                            title="Client List"
                            color="#d9e3f0"
                            value="Clientlist"
                        ></v-list-item>
                    </Link>
                </v-list-group>

                <!---Saw Cutting--->
                <v-list-group
                    color="whitesmoke"
                    v-if="can('page SAW')"
                    value="SAW"
                >
                    <template v-slot:activator="{ props }">
                        <v-list-item
                            prepend-icon="mdi:mdi-hand-saw"
                            v-bind="props"
                            title="Saw Cutting"
                        ></v-list-item>
                    </template>
                    <Link
                        :href="route('SAW-opsDash')"
                        @click="setDepartment('SAW')"
                    >
                        <v-list-item
                            rounded="xl"
                            title="SAW Ops Dashboard"
                            value="SAWOPSDashboard"
                            color="#d9e3f0"
                        ></v-list-item>
                    </Link>
                    <Link
                        :href="route('cnc.routeCreateCutRequest')"
                        @click="setDepartment('SAW')"
                    >
                        <v-list-item
                            rounded="xl"
                            title="Create Cut Request"
                            value="SAWCreateCutRequest"
                            color="#d9e3f0"
                        ></v-list-item>
                    </Link>
                    <Link
                        :href="route('cnc.cutRequestList')"
                        @click="setDepartment('SAW')"
                    >
                        <v-list-item
                            rounded="xl"
                            title="Cut Request List"
                            value="SAWCutRequestList"
                            color="#d9e3f0"
                        ></v-list-item>
                    </Link>
                    <Link
                        :href="route('cnc.cutRequestHistory')"
                        @click="setDepartment('SAW')"
                    >
                        <v-list-item
                            rounded="xl"
                            title="Cut Request History"
                            value="SAWRequestHistory"
                            color="#d9e3f0"
                        ></v-list-item>
                    </Link>
                    <Link
                        :href="route('project-request-material')"
                        @click="setDepartment('SAW')"
                    >
                        <v-list-item
                            rounded="xl"
                            title="Request Material"
                            value="SAWRequestMaterial"
                            color="#d9e3f0"
                        ></v-list-item>
                    </Link>
                    <Link
                        :href="route('SAW-resourceLinks')"
                        @click="setDepartment('SAW')"
                    >
                        <v-list-item
                            rounded="xl"
                            title="Tablet Resource Links"
                            value="SAWTabletResourceLinks"
                            color="#d9e3f0"
                        ></v-list-item>
                    </Link>
                    <!--                    <Link :href="route('SAW-extrusionInventoryRoute')">-->
                    <!--                        <v-list-item-->
                    <!--                            rounded="xl"-->
                    <!--                            title="Extrusion Inventory"-->
                    <!--                            value="ExtrusionInventory"-->
                    <!--                            color="#d9e3f0"-->
                    <!--                        ></v-list-item>-->
                    <!--                    </Link>-->

                    <Link
                        :href="route('project-material-sheet')"
                        @click="setDepartment('SAW')"
                    >
                        <v-list-item
                            rounded="xl"
                            title="Material Sheet Inventory"
                            value="SAWMaterialSheetInventory"
                            color="#d9e3f0"
                        ></v-list-item>
                    </Link>
                </v-list-group>


                <!----Supply Chain---->
                <v-list-group
                    color="whitesmoke"
                    v-if="can('page Supply Chain')"
                    value="SupplyChainGroup"
                >
                    <template v-slot:activator="{ props }">
                        <v-list-item
                            @click="setDepartment('SC')"
                            prepend-icon="mdi:mdi-warehouse"
                            v-bind="props"
                            title="Supply Chain"
                        ></v-list-item>
                    </template>
                    <Link
                        :href="route('supply-chain-checkList')"
                        @click="setDepartment('SC')"
                    >
                        <v-list-item
                            rounded="xl"
                            title="Supply Chain Checklist"
                            value="PSupplyChecklist"
                            color="#d9e3f0"
                        ></v-list-item>
                    </Link>
                    <Link
                        :href="route('supply-chain-structure')"
                        @click="setDepartment('SC')"
                    >
                        <v-list-item
                            rounded="xl"
                            title="Supply Chain Structural"
                            value="PSupplyStructural"
                            color="#d9e3f0"
                        ></v-list-item>
                    </Link>
                    <Link
                        :href="route('purchasing-supplyRequestDash')"
                        @click="setDepartment('SC')"
                    >
                        <v-list-item
                            title="Supply Request"
                            rounded="xl"
                            color="#d9e3f0"
                            value="SupplyRequestFormSC"
                        ></v-list-item>
                    </Link>
                </v-list-group>

                <!--Sustainability--->
                <v-list-group
                    color="whitesmoke"
                    v-if="can('sustainability pages')"
                    value="SustaintabilityVal"
                >
                    <template v-slot:activator="{ props }">
                        <v-list-item
                            prepend-icon="mdi:mdi-earth"
                            v-bind="props"
                            title="Sustaintability"
                        ></v-list-item>
                    </template>

                    <Link
                        v-if="can('page Shift Calendar')"
                        :href="route('SUS-shiftCalendar')"
                        @click="setDepartment('SUS')"
                    >
                        <v-list-item
                            rounded="xl"
                            title="Shift Calendar"
                            color="#d9e3f0"
                            value="SUSShiftCalendar"
                        >
                        </v-list-item>
                    </Link>
                </v-list-group>

                <!---Vac Thermoforming----->
                <v-list-group
                    color="whitesmoke"
                    v-if="can('page Thermoforming')"
                    value="Thermo"
                >
                    <template v-slot:activator="{ props }">
                        <v-list-item
                            prepend-icon="mdi:mdi-star-three-points"
                            v-bind="props"
                            title="Thermoforming"
                        ></v-list-item>
                    </template>
                    <Link
                        :href="route('VACF-opsDash')"
                        @click="setDepartment('THM')"
                    >
                        <v-list-item
                            rounded="xl"
                            title="VACF Ops Dashboard"
                            value="VACFOPSDashboard"
                            color="#d9e3f0"
                        ></v-list-item>
                    </Link>
                    <Link
                        :href="route('project-request-material')"
                        @click="setDepartment('THM')"
                    >
                        <v-list-item
                            rounded="xl"
                            title="Request Material"
                            value="VACFRequestMaterial"
                            color="#d9e3f0"
                        ></v-list-item>
                    </Link>
                    <Link
                        :href="route('cnc.routeCreateCutRequest')"
                        @click="setDepartment('THM')"
                    >
                        <v-list-item
                            rounded="xl"
                            title="Create Cut Request"
                            value="VACFCreateCutRequest"
                            color="#d9e3f0"
                        ></v-list-item>
                    </Link>
                    <Link
                        :href="route('cnc.cutRequestList')"
                        @click="setDepartment('THM')"
                    >
                        <v-list-item
                            rounded="xl"
                            title="Cut Request List"
                            color="#d9e3f0"
                            value="VACFCutRequestList"
                        ></v-list-item>
                    </Link>
                    <Link
                        v-if="can('page Shift Calendar')"
                        :href="route('VACF-shiftCalendar')"
                        @click="setDepartment('THM')"
                    >
                        <v-list-item
                            rounded="xl"
                            title="Shift Calendar"
                            value="VACFShiftCalendar"
                            color="#d9e3f0"
                        >
                        </v-list-item>
                    </Link>
                    <Link
                        :href="route('VACF-resourceLinks')"
                        @click="setDepartment('THM')"
                    >
                        <v-list-item
                            rounded="xl"
                            title="Tablet Resource Links"
                            value="VACFTabletResourceLinks"
                            color="#d9e3f0"
                        ></v-list-item>
                    </Link>
                </v-list-group>
            </v-list>
            <template v-slot:append>
                <div style="display: flex; justify-content: space-between">
                    <div class="pa-2">
                        <v-btn
                            @click="showSettings = !showSettings"
                            variant="text"
                            color="white"
                            icon="mdi:mdi-cog"
                        >
                        </v-btn>
                    </div>
                    <div class="pa-2">
                        <v-btn
                            variant="text"
                            color="white"
                            icon="mdi:mdi-account-arrow-right"
                            @click="logOut"
                        >
                        </v-btn>
                    </div>
                </div>
            </template>
        </v-navigation-drawer>

        <!-- SETTINGS DRAWER ----------------------------------------------------------------------------------------------------->
        <v-navigation-drawer
            v-model="showSettings"
            location="right"
            color="grey-lighten-1"
            temporary
        >
            <v-container>
                <v-row>
                    <v-col>
                        <a href="https://workforcenow.adp.com" target="_blank">
                            <v-btn
                                color="primary"
                                prepend-icon="mdi:mdi-calendar-check"
                                class="text-white"
                            >
                                Time-Off
                            </v-btn>
                        </a>
                    </v-col>
                </v-row>
            </v-container>
        </v-navigation-drawer>

        <!-- CHATBOT DRAWER ----------------------------------------------------------------------------------------------------->
        <v-navigation-drawer
            temporary
            v-model="openChatModal"
            location="right"
            color="grey-lighten-2"
            width="600"
        >
            <v-container>
                <ChatBot :usingVoiceChat="usingVoiceChat" />
            </v-container>
        </v-navigation-drawer>

        <v-app-bar
            style="
                background: linear-gradient(90deg, #f9fdfb 17%, #e1e9f2);
                color: black;
            "
            dark
            prominent
        >
            <v-app-bar-nav-icon
                variant="text"
                @click.stop="drawer = !drawer"
            ></v-app-bar-nav-icon>
            <v-toolbar-title>
                <Link :href="route('home')">
                    <img
                        src="/images/D3_Connectv2.png"
                        alt="D3 Connect"
                        :style="
                            this.screenWidth > 445
                                ? 'max-height:35px'
                                : 'max-height:20px'
                        "
                    />
                </Link>
            </v-toolbar-title>
            <v-toolbar-items>
                <v-btn
                    v-if="can('View Chatbot')"
                    variant="text"
                    @click="openChatModal = !openChatModal"
                    class="ma-2"
                    size="large"
                >
                    <v-icon
                        size="x-large"
                        color="primary"
                        icon="mdi:mdi-chat-plus"
                    ></v-icon>
                </v-btn>

                <v-btn
                    style="margin-right: 25px !important"
                    variant="text"
                    @click="showSettings = !showSettings"
                    class="ma-2"
                    size="large"
                >
                    <v-icon
                        size="x-large"
                        color="primary"
                        icon="mdi:mdi-calendar-clock"
                    ></v-icon>
                </v-btn>

                <v-avatar class="mobile-avatar" size="38">
                    <v-img
                        v-if="countryCode === 'US'"
                        src="/images/us.svg"
                        alt="US"
                    ></v-img>
                    <v-img
                        v-if="countryCode === 'FR'"
                        src="/images/fr.svg"
                        alt="US"
                    ></v-img>
                    <v-img
                        v-if="countryCode === 'BR'"
                        src="/images/br.svg"
                        alt="US"
                    ></v-img>
                </v-avatar>
                <v-btn type="text" color="primary">
                    <v-avatar class="user-icon">
                        <span style="font-weight: bold">{{ initials }}</span>
                    </v-avatar>
                    <v-menu activator="parent" open-on-hover>
                        <v-list>
                            <Link class="nav-list-link" @click="logOut">
                                <v-list-item>
                                    <v-list-item-title
                                        >Log Out</v-list-item-title
                                    >
                                </v-list-item>
                            </Link>
                        </v-list>
                    </v-menu>
                </v-btn>
            </v-toolbar-items>
        </v-app-bar>
        <v-main
            class="fill-height"
            :scrollable="true"
            style="background-color: #f0f2f5"
        >
            <div class="pa-3 fill-height">
                <slot />
            </div>
        </v-main>
        <PatchNoteDialog
            v-model="dialogOpen"
            :patch-note="currentPatchNote"
            :loading="patchNoteLoading"
            @acknowledge="acknowledge"
        />
    </v-app>
</template>

<script>
import { Link } from "@inertiajs/inertia-vue3";
import { mapState, mapActions, mapWritableState } from "pinia";
import { useRequestStore } from "../stores/TempRequest/TempRequest";
import { supplyRequestStore } from "../stores/Purchasing/SupplyRequest";
import { usePatchNoteStore } from "../stores/PatchNotes/PatchNotes.js";
import { defineAsyncComponent } from "vue";
import { Inertia } from "@inertiajs/inertia";
import axios from "axios";

const ChatBot = defineAsyncComponent(() =>
    import("../components/D3Bot/ChatBotModal.vue")
);
const PatchNoteDialog = defineAsyncComponent(() =>
    import("../components/PatchNotes/PatchNoteDialog.vue")
);
export default {
    components: {
        Link,
        ChatBot,
        PatchNoteDialog,
    },
    data: () => ({
        admins: [
            ["Management", "mdi:mdi-account-multiple-outline"],
            ["Settings", "mdi:mdi-cog-outline"],
        ],
        drawer: false,
        group: null,
        showSettings: false,
        heading: null,
        firstName: null,
        lastName: null,
        departmentFK: null,
        buildingFK: null,
        listGroupOpen: false,
        screenWidth: window.innerWidth,
        tempRequestInterval: null,
        supplyRequestInterval: null,
        projectManRequestInterval: null,
        approvalCount: 0,
        openChatModal: false,
        porcupineWorker: null,
        usingVoiceChat: false,
    }),
    watch: {
        group() {
            this.drawer = false;
        },
    },
    computed: {
        fullName() {
            if (this.$page.props.auth.check)
                return `${this.$page.props.auth.user.firstName} ${this.$page.props.auth.user.lastName}`.trim();
        },
        initials() {
            const name = this.fullName;
            if (!name) return "";

            // Split the full name into an array of words
            const nameArray = name.split(" ");

            // Get the first character of each word and join them
            const initials = nameArray
                .map((word) => word.charAt(0).toUpperCase())
                .join("");

            return initials;
        },
        countryCode() {
            if (this.$page?.props?.auth?.user?.countryCodeFK === "US") {
                return "US";
            }
            if (this.$page?.props?.auth?.user?.countryCodeFK === "FR") {
                return "FR";
            }
            if (this.$page?.props?.auth?.user?.countryCodeFK === "BR") {
                return "BR";
            }
        },
        ...mapState(useRequestStore, [
            "loading",
            "newRequestCount",
            "cancelRequestCount",
        ]),
        ...mapState(supplyRequestStore, [
            "supplyLoading",
            "supplyRequestsCount",
        ]),
        ...mapState(usePatchNoteStore, {
            currentPatchNote: "currentPatchNote",
            patchNotes: "patchNotes",
            activeDepartment: "activeDepartment",
            patchNoteLoading: "loading",
        }),
        ...mapWritableState(usePatchNoteStore, ["dialogOpen"]),
    },
    created() {
        window.addEventListener("resize", this.updateScreenWidth);
    },
    destroyed() {
        window.removeEventListener("resize", this.updateScreenWidth);
    },
    beforeDestroy() {
        // Clear the interval when the component is destroyed to prevent memory leaks
        if (this.tempRequestInterval) {
            clearInterval(this.tempRequestInterval);
        }
        if (this.projectManRequestInterval) {
            clearInterval(this.projectManRequestInterval);
        }
        if (this.supplyRequestInterval) {
            clearInterval(this.supplyRequestInterval);
        }
    },
    mounted() {
        //this.initWakeWord();
        if (this.$page.props.auth.check) {
            this.firstName = this.$page.props.auth.user.firstName;
            this.lastName = this.$page.props.auth.user.lastName;
            this.departmentFK = this.$page.props.auth.user.departmentFK;
            this.buildingFK = this.$page.props.auth.user.buildingFK;
        } //
        if (
            window.Laravel?.jsPermissions?.permissions?.includes("manage temps")
        ) {
            this.getRequests("P");

            // Set an interval to call the function every 10 minutes (10 * 60 * 1000 ms)
            this.tempRequestInterval = setInterval(() => {
                this.getRequests("P");
            }, 30 * 60 * 1000);
        }
        if (window.Laravel?.jsPermissions?.permissions?.includes("create po")) {
            this.getCount();
            this.supplyRequestInterval = setInterval(() => {
                this.getCount();
            }, 30 * 60 * 1000);
        }
        if (window.Laravel?.jsPermissions?.permissions?.includes("create po")) {
            this.codeGeneratorCount();
            this.supplyRequestInterval = setInterval(() => {
                this.codeGeneratorCount();
            }, 30 * 60 * 1000);
        }
    },
    methods: {
        logOut() {
            try {
                try {
                    localStorage.clear();
                    sessionStorage.clear();
                    axios.get(route("logout")).then((res) => {
                        window.location.replace("/");
                    });
                } catch (err) {
                    console.log(err);
                }
            } catch (error) {
                console.error("Logout failed", error);
            }
        },
        async codeGeneratorCount() {
            try {
                await axios
                    .get(route("legacy-api.CheckForApprovals"))
                    .then((res) => {
                        this.approvalCount = res.data.Array.length;
                    });
            } catch (err) {
                console.log(err);
            }
        },
        ...mapActions(useRequestStore, ["getRequests"]),
        ...mapActions(supplyRequestStore, ["getCount"]),
        ...mapActions(usePatchNoteStore, [
            "setDepartment",
            "fetchPending",
            "showNext",
            "acknowledge",
        ]),
        updateScreenWidth() {
            this.screenWidth = window.innerWidth;
        },
        async initWakeWord() {
            if (!("webkitSpeechRecognition" in window)) {
                console.error(
                    "SpeechRecognition not supported in this browser."
                );
                return;
            }

            const recognition = new webkitSpeechRecognition(); // Chrome only
            recognition.continuous = true;
            recognition.interimResults = false;
            recognition.lang = "en-US";

            recognition.onresult = (event) => {
                for (let i = event.resultIndex; i < event.results.length; ++i) {
                    if (event.results[i].isFinal) {
                        const transcript = event.results[i][0].transcript
                            .trim()
                            .toLowerCase();
                        console.log("Heard:", transcript);

                        if (transcript.includes("d3")) {
                            this.usingVoiceChat = true;
                            this.openChatModal = true;
                            recognition.stop();
                        }
                    }
                }
            };

            recognition.onerror = (event) => {
                console.error("Speech recognition error:", event.error);
            };

            recognition.onend = () => {
                // Automatically restart listening
                recognition.start();
            };

            // Start listening
            recognition.start();
        },
    },
};
</script>

<style scoped lang="css">
.innerGroup {
    margin-left: -35px;
}

p {
    padding-top: 8px;
}

@media (max-width: 1000px) {
    .mobile-avatar {
        display: none;
    }
}
.mobile-avatar {
    margin-top: 13px;
}
:deep(.v-list-item__append) {
    font-size: 9px !important;
}

:deep(.v-list-item--nav .v-list-item-title) {
    font-family: sans-serif;
}

:deep(.v-list-item--variant-text .v-list-item__overlay) {
    margin-right: -45px;
}

.user-icon {
    cursor: pointer;
    background-color: #3b3d4d;
    color: whitesmoke;
}
.chat-image {
    background-image: url("/images/World-map.jpg");
    background-size: cover;
    background-position: center;
    height: 93vh;
}
</style>
